import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  state?: 'default' | 'error' | 'success';
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className = '', icon, state = 'default', ...props }, ref) => {
  const stateStyles: Record<string, string> = {
    default: 'border-slate-200 focus-visible:ring-[#0B3C5D]',
    error: 'border-red-300 focus-visible:ring-red-500 bg-red-50/30',
    success: 'border-green-300 focus-visible:ring-green-500 bg-green-50/30',
  };

  return (
    <div className="relative">
      {icon && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
          {icon}
        </div>
      )}
      <input
        ref={ref}
        className={`flex h-12 w-full rounded-2xl border bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${stateStyles[state]} ${icon ? 'pl-10' : ''} ${className}`}
        {...props}
      />
    </div>
  );
});

Input.displayName = 'Input';
